<form [meta]="model" #form="ngForm" column-classes="col-md-4,col-md-8">
  @if (model) {
    <div class="row mt-2">
      <div class="col-6">
        <div>
          <h3 class="title-divider">{{ "datenexport.auftrag" | translate }}</h3>
          <div class="mt-2">
            <cap-form-control invalidKey="EingabeDarfNichtLeerSein" labelKey="datenexport.ausfuehrungsdatum">
              <cap-datepicker
                (click)="forceMinDate()"
                [(ngModel)]="model.ausfuehrungsdatum"
                [capMinDate]="minDate"
                appAutofocus
                name="ausfuehrungsdatum">
              </cap-datepicker>
            </cap-form-control>
            <cap-form-control invalidKey="EingabeDarfNichtLeerSein" labelKey="datenexport.periodizitaet">
              <select [(ngModel)]="model.periodizitaet" [disabled]="!periodischeAuftraege" name="periodizitaet">
                @for (item of periodizitaetValues; track item) {
                  <option [value]="item">
                    {{ item | translate }}
                  </option>
                }
              </select>
            </cap-form-control>
            <cap-form-control labelKey="datenexport.prioritaet">
              <select [(ngModel)]="model.prioritaet" name="prioritaet">
                @for (item of prioritaetValues; track item) {
                  <option [value]="item">
                    {{ item | translate }}
                  </option>
                }
              </select>
            </cap-form-control>
            <cap-form-control invalidKey="EingabeDarfNichtLeerSein" labelKey="datenexport.format">
              <select [(ngModel)]="model.format" name="format">
                @for (item of formatValues; track item) {
                  <option [value]="item">
                    {{ item | translate }}
                  </option>
                }
              </select>
            </cap-form-control>
          </div>
        </div>
        <div>
          <h3 class="title-divider">{{ "datenexport.informationAnFolgendeEmpfaenger" | translate }}</h3>
          <div class="mt-2">
            <cap-form-control invalidKey="EingabeMussValideEmailSein" labelKey="datenexport.email1">
              <input [(ngModel)]="model.email1" name="email1" type="email" />
            </cap-form-control>
            <cap-form-control invalidKey="EingabeMussValideEmailSein" labelKey="datenexport.email2">
              <input [(ngModel)]="model.email2" name="email2" type="email" />
            </cap-form-control>
            <cap-form-control invalidKey="EingabeMussValideEmailSein" labelKey="datenexport.email3">
              <input [(ngModel)]="model.email3" name="email3" type="email" />
            </cap-form-control>
          </div>
        </div>
      </div>
      <div class="col-6">
        <h3 class="title-divider">{{ "datenexport.auftragstitelUndBeschreibung" | translate }}</h3>
        <div class="mt-2">
          <cap-form-control invalidKey="EingabeNichtValide(1-30Zeichen)" labelKey="datenexport.titel">
            <input [(ngModel)]="model.auftragsTitel" name="auftragsTitel" type="text" />
          </cap-form-control>
        </div>
        <div class="mt-2">
          <cap-form-control invalidKey="EingabeIstZuLange" labelKey="datenexport.beschreibung">
            <textarea
              [(ngModel)]="model.auftragsBeschreibung"
              class="textarea-detail col-md-12 m-0"
              name="auftragsBeschreibung"
              rows="12"
              style="height: 100%; resize: none"
              type="text">
            </textarea>
          </cap-form-control>
        </div>
      </div>
    </div>
  }

  @if (false) {
    <div class="row mt-2">
      <!-- Erst mit CGE -->
      <div class="col-12">
        <h3 class="title-divider">{{ "datenexport.detailsZumAuftraggeber" | translate }}</h3>
      </div>
    </div>
  }

  @if (!readonly) {
    <div class="p-2" id="actionpane">
      <div class="rechtsbuendig">
        <button cdkStepperPrevious class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurück" | translate }}</button>
        <button class="btn btn-outline-primary btn-actionpane" routerLink=".." type="button">{{ "Abbrechen" | translate }}</button>
        <button
          (click)="onSave()"
          [disabled]="!form.form.valid || saveRequestRunning"
          cdkStepperNext
          class="btn btn-primary btn-actionpane"
          type="submit">
          {{ "Auftrag senden" | translate }}
        </button>
      </div>
    </div>
  }
</form>
